import { render, staticRenderFns } from "./CreateServiceAccountPage.vue?vue&type=template&id=55112de4"
import script from "./CreateServiceAccountPage.vue?vue&type=script&lang=ts"
export * from "./CreateServiceAccountPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports